// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.downloadIcon{\n  height: 15px;\n    vertical-align: middle;\n    position: relative;\n    left: 21px;cursor:pointer\n}\n.redbold {\n  color: red;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
